/**
 * Session key for IO server (`?jwtContext=`) and Chrome OAuth callback.
 * Scoped per extension install + Gmail account so one browser profile can keep distinct server sessions.
 */
export function buildChromeLoginJwtContext(extensionId: string, email: string): string {
  return `chrome:${extensionId}:${email}`;
}
